import { OFFER_TYPE_HOTEL, OFFER_TYPE_LAST_MINUTE_HOTEL, OFFER_TYPE_TACTICAL_AO_HOTEL } from '~/consts/offerTypes';
import type { TagType } from '~/consts/tags';
import { TAG_TYPE_CAMPAIGN, TAG_TYPE_HOLIDAY } from '~/consts/tags';

export type MarketingVerticalId = 'hotels' | 'cruises' | 'experiences' | 'tours';

export type MarketingVerticalConfig = {
  id: MarketingVerticalId;
  label: string;
  supportedTagTypes: Array<TagType>;
  offerIdPlaceholder: string;
  csvTemplateExampleIds: Array<string>;
};

export const MARKETING_VERTICALS: Array<MarketingVerticalConfig> = [
  {
    id: 'hotels',
    label: 'Hotels',
    supportedTagTypes: [TAG_TYPE_HOLIDAY, TAG_TYPE_CAMPAIGN],
    offerIdPlaceholder:
      'Enter flash/LPC offer IDs (e.g. OFF123) or bedbank property UUIDs, separated by commas or new lines',
    csvTemplateExampleIds: ['OFF123', 'a1b2c3d4-e5f6-7890-abcd-ef1234567890'],
  },
  {
    id: 'cruises',
    label: 'Cruises',
    supportedTagTypes: [TAG_TYPE_CAMPAIGN],
    offerIdPlaceholder: 'Enter cruise offer UUIDs separated by commas or new lines',
    csvTemplateExampleIds: ['efbc89fa-8dc1-4957-93aa-c4825258bef8'],
  },
  {
    id: 'experiences',
    label: 'Experiences',
    supportedTagTypes: [TAG_TYPE_CAMPAIGN],
    offerIdPlaceholder: 'Enter experience offer IDs separated by commas or new lines (e.g. cmc:DAYKUACE)',
    csvTemplateExampleIds: ['cmc:DAYKUACE'],
  },
  {
    id: 'tours',
    label: 'Tours',
    supportedTagTypes: [TAG_TYPE_CAMPAIGN],
    offerIdPlaceholder:
      'Enter tour IDs separated by commas or new lines (e.g. tour-801fb35a-e3ce-4bdb-a757-5fd4be0d6416)',
    csvTemplateExampleIds: ['tour-801fb35a-e3ce-4bdb-a757-5fd4be0d6416'],
  },
];

/** svc-offer hotel verticals covered by the Hotels tab (flash, last-minute, LPC). */
export const SVC_OFFER_HOTEL_TYPES = [OFFER_TYPE_HOTEL, OFFER_TYPE_LAST_MINUTE_HOTEL, OFFER_TYPE_TACTICAL_AO_HOTEL];

export function getVerticalConfig(verticalId: MarketingVerticalId): MarketingVerticalConfig {
  const config = MARKETING_VERTICALS.find((vertical) => vertical.id === verticalId);
  if (!config) {
    throw new Error(`Unknown marketing vertical: ${verticalId}`);
  }
  return config;
}
